(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klyr-customer-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('klyr-customer-stories')) {
  customElements.define('klyr-customer-stories', class extends HTMLElement {
    connectedCallback() {
      if(this._events) return;
      this._events=new AbortController();
      this.classList.add('is-enhanced');
      this.querySelectorAll('.kcs__toggle').forEach(button=>{
        button.hidden=false;
        button.addEventListener('click',()=>{
          const expanded=button.getAttribute('aria-expanded')==='true';
          const card=button.closest('.kcs__card');
          const top=card.getBoundingClientRect().top;
          button.setAttribute('aria-expanded',String(!expanded));
          card.querySelector('.kcs__text').classList.toggle('is-open',!expanded);
          if(expanded && top<0) card.scrollIntoView({block:'start',inline:'nearest',behavior:'instant'});
        },{signal:this._events.signal});
      });
      const track=this.querySelector('.kcs__track');
      const buttons=[...this.querySelectorAll('[data-direction]')];
      const update=()=>{const media=track.querySelector('.kcs__media');if(media)this.style.setProperty('--kcs-nav-top',`${media.getBoundingClientRect().height/2}px`);const max=track.scrollWidth-track.clientWidth;const x=Math.max(0,track.scrollLeft);buttons[0].disabled=x<2;buttons[1].disabled=x>=max-2;this.style.setProperty('--kcs-progress',`${max>0?x/max*900:0}%`);};
      buttons.forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.kcs__card');const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:Number(button.dataset.direction)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},{signal:this._events.signal}));
      track.addEventListener('scroll',update,{passive:true,signal:this._events.signal});
      this._resize=new ResizeObserver(update);this._resize.observe(track);update();
    }
    disconnectedCallback(){this._events?.abort();this._events=null;this._resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klyr-results"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('klyr-results'))customElements.define('klyr-results',class extends HTMLElement{
connectedCallback(){if(this.events)return;this.events=new AbortController();const track=this.querySelector('.krs__track'),buttons=[...this.querySelectorAll('[data-step]')];const update=()=>{const max=track.scrollWidth-track.clientWidth,x=Math.max(0,track.scrollLeft);buttons[0].disabled=x<2;buttons[1].disabled=x>=max-2;this.style.setProperty('--krs-progress',`${max>0?Math.min(1,x/max)*400:0}%`)};buttons.forEach(b=>b.addEventListener('click',()=>{const pair=track.querySelector('.krs__pair');if(!pair)return;track.scrollBy({left:Number(b.dataset.step)*(pair.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})},{signal:this.events.signal}));track.addEventListener('scroll',update,{passive:true,signal:this.events.signal});this.observer=new ResizeObserver(update);this.observer.observe(track);update()}
disconnectedCallback(){this.events?.abort();this.events=null;this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
